import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import SearchPatientComponent from "./SearchPatientComponent";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar.svg";
import { useNavigate, useParams } from "react-router-dom";
import PatientLoader from "../../common/PatientLoader";
import HorizontalSwitcherComponent from "./HorizontalSwitcherComponent";
import BasicInformation from "./InfoTabs/BasicInformation";
import FlaggedJournals from "./InfoTabs/FlaggedJournals";
import FlaggedAssessments from "./InfoTabs/FlaggedAssessments";
import StickyChat, { MiniChat } from "../../common/stickyChat/StickyChat";
import CheckInOverview, {
  CheckInOverviewTable,
} from "./InfoTabs/CheckInOverview/CheckInOverview";
import { PHQAssessment } from "./InfoTabs/CheckInOverview/PHQAssessment";
import { GADAssessment } from "./InfoTabs/CheckInOverview/GADAssessment";
import SDOHResults from "./InfoTabs/SDOHResults";
import AllAssessments from "./InfoTabs/AllAssessments";
import Journals from "./InfoTabs/Journals";
import PatientNotes from "./InfoTabs/PatientNotes/PatientNotes";
import PinnedContent from "./InfoTabs/PinnedContent/PinnedContent";
import DateRangeComponent from "./InfoTabs/DateRangeComponent";
import DBTContent from "./InfoTabs/DBTContents/DBTContent";
import BillingNotes from "./InfoTabs/BillingNotes/BillingNotes";
import {
  checkPatientExists,
  fetchPatientNotesLogic,
  singlePatientLogic,
} from "../../../store/features/patient/patientSlice";
import { getPatientBHIDataLogic } from "../../../store/features/patient/bhiSlice";
import {
  fetchAllAssessmentsLogic,
  fetchAssessmentTypesLogic,
  fetchDBTAssessmentsLogic,
  fetchPateintAssessmentsLogic,
  fetchRecentAssessmentsLogic,
  fetchDBTDetailsLogic,
  fetchDBTChartDataLogic,
  fetchSDOHPatientResultsLogic,
  fetchCaregiverRecentAssessmentLogic,
  fetchCaregiverAllAssessmentsLogic,
} from "../../../store/features/patient/assessmentsSlice";
import { getFullName, notify, playMessageSound } from "../../../util/helpers";
import moment from "moment";
import { getSinglePatientChat } from "../../../store/features/chat/chatSlice";
import AgoraClientComponent, {
  chatStructureHelper,
} from "../chat/AgoraMethods";
import DummyClient from "../chat/DummyClient";
import IncomingMessage from "../../../assets/sounds/IncomingMessage.mp3";
import PatientAssessment from "./InfoTabs/PatientAssessment";
import PatientAssessmentModal from "./Assessments/PatientAssessmentModal";
import DualLoginModal from "../chat/DualLoginModal";
import PatientIntroLayer from "./PatientComponents/PatientIntroLayer";
import "./PatientStyles.css";
import { Helmet } from "react-helmet";
import PatientActionButton from "./PatientComponents/PatientActionButton";
import { capitalize } from "lodash";
import { dateFilters, notesFilter } from "../../../constants/constants";
import { fetchTWSCoordinatorLogic } from "../../../store/features/app/appSlice";
import "rsuite/dist/rsuite.min.css";
import { DateRangePicker } from "rsuite";
import DBTTable from "./InfoTabs/DBTContents/DBTTable";
import { ProfilePDF } from "./PatientComponents/ProfilePDF";
import DBTStreak from "./InfoTabs/DBTContents/DBTStreak";
import ScaredAssessmentGraph from "./PatientComponents/ScaredAssessmentGraph";
import { isEmptyObject } from "jquery";
import JournalAnalysis from "./InfoTabs/JournalAnalysis";
import DailyPieChart from "./PatientComponents/DailyPieChart";
const PatientDashboard = (props) => {
  const [currentTab, setCurrentTab] = useState(1);
  const [remoteShow, setRemoteShow] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  const setJournalsTab = () => {
    setCurrentTab(4);
  };
  const setPatientNotesTab = () => {
    setCurrentTab(5);
  };

  const setAssessmentsTab = () => {
    setCurrentTab(2);
  };

  const setCheckinTab = () => {
    setCurrentTab(3);
  };

  const setPinnedContentTab = () => {
    setCurrentTab(6);
  };
  const setDBTContentTab = () => {
    setCurrentTab(7);
  };
  const [isChatExanpded, setIsChatExanpded] = useState(false);
  const [unreadCount, setUnreadCount] = useState(false);
  //* Some Date Magic to use as default data fetching filters
  let today = moment(new Date()).format("YYYY-MM-DD");
  const fiveDaysFromToday = moment(today)
    .subtract(6, "months")
    .format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(fiveDaysFromToday);
  const [notesFilterValue, setNotesFilterValue] = useState(notesFilter[0]);
  const [journalFilterValue, setJournalFilterValue] = useState(dateFilters[5]);
  const [endDate, setEndDate] = useState(today);
  const [chatData, setChatData] = useState([]);
  const [inChatMessage, setInChatMessage] = useState(null);
  const {
    loading,
    singlePatientData,
    patientNotesLoading,
    patientNotes,
    caregiverLoading,
    caregiverError,
    caregiverData,
  } = useSelector((state) => state.patient);
  const { bhiLoading } = useSelector((state) => state.bhi);
  const { assessmentsLoading, recentAssessments } = useSelector(
    (state) => state.assessment
  );
  const [billingNotesFilter,setBillingsFilter] = useState()

  const handleIncomingMessage = (message, peerID) => {
    if (!sessionStorage.getItem("openChatIDMini")) {
      sessionStorage.setItem("openChatIDMini", singlePatientData?.id);
    }

    if (!isChatExanpded) {
      console.log("Incoming message")
      setUnreadCount(unreadCount + 1);
      playMessageSound();
    } else {
      setInChatMessage(message);
    }
  };
  const { user, selectedProvider, selectedClinic } = useSelector(
    (state) => state.app
  );
  const clinicianId = selectedProvider ? selectedProvider : user?.id;
  const clinicianName = getFullName(user);
  const dispatch = useDispatch();
  const [patientID, setPatientID] = useState(parseInt(params?.patientid));

  const { assessmentLoading, assessmentsData } = useSelector(
    (state) => state.assessment
  );
  const [patientAssessments, setPatientAssessments] = useState([]);
  const [patientAssessmentLoading, setPatientAssessmentLoading] =
    useState(false);
  const { combine, allowedMaxDays, afterToday } = DateRangePicker;
  const [dateRange, setDateRange] = useState([
    new Date(moment().startOf("week").format("YYYY-MM-DD")),
    new Date(moment().endOf("week").format("YYYY-MM-DD")),
  ]);
  const [dbtStartDate, setdbtStartDate] = useState(
    moment(dateRange[0]).format("YYYY-MM-DD")
  );
  const [dbtEndDate, setdbtEndDate] = useState(
    moment(dateRange[1]).format("YYYY-MM-DD")
  );
  const [dbtData, setDbtData] = useState();
  const [cmData, setCmData] = useState(); //*This represents core_mindfulness
  const [ieData, setIeData] = useState(); //*This represents interpersonal_effectiveness
  const [dtData, setDtData] = useState(); //*This represents distress_tolerance
  const [erData, setErData] = useState(); //*This represents emotion_regulation
  const [wtmpData, setWtmpData] = useState(); //*This represents wtmp
  const [dbtChartData, setDbtChartData] = useState([]);
  const [downloadMode, setDownloadMode] = useState(false); //* This is for Patient's Profile Page PDF download
  const [notesDownloadMode, setNotesDownloadMode] = useState(false); //* This is for the Patient's ALL Notes PDF download
  const [scaredAssessmentData, setScaredAssessmentData] = useState({
    labels: [],
    values: [],
  });
  const [columbiaAssessmentData, setColumbiaAssessmentData] = useState({
    labels: [],
    values: [],
  });
  const [caregiverAssesments, setCaregiverAssessments] = useState([]);
  const[caregiverRecentAssessment, setCaregiverRecentAssessment] = useState([]);
  const [caregiverAllAssesments, setCaregiverAllAssessments] = useState([]);
  // const [cargiverassessmentLoading, setCargiverassessmentLoading] = useState(true);

  //THIS IS FOR CAREGIVER
  const fetchCaregiverAssessments = (patientID) => {
    fetchPateintAssessmentsLogic(patientID)
      .then((result) => {
        setCaregiverAssessments(result.data);
      })
      .catch((error) => {
        notify("Something went wrong", "error");
        console.log(error);
      });
  };
  const fetchCaregiverRecentAssessmentData = (patientID) =>{
    fetchCaregiverRecentAssessmentLogic(patientID)
    .then((result)=>{
      setCaregiverRecentAssessment(result.data);
      })
      .catch((error) => {
        notify("Something went wrong", "error");
        console.log(error);
      })
      // .finally(() => {setCargiverassessmentLoading(false);});
  }
  const fetchCaregiverAllAssessments = (payload) =>{
    fetchCaregiverAllAssessmentsLogic(payload)
    .then((result)=>{
      setCaregiverAllAssessments(result.data);
    })
    .catch((error) => {
      notify("Something went wrong", "error");
      console.log(error);
    });
  }

  useEffect(() => {
    if (assessmentLoading || process.env.REACT_APP_DASHBOARD_TYPE !== "youth")
      return;
    if (!isEmptyObject(assessmentsData)) {
      formatYouthGraphData(); //* This curates data for SCARED and Columbia assessments for Youth Env ONLY!
    }
    // console.log("caregiverRecentAssessment",caregiverRecentAssessment)
    // console.log("recentAssessments",recentAssessments)//
    // console.log("caregiverAllAssesments",caregiverAllAssesments)
  }, [assessmentLoading, assessmentsData]);

  function formatYouthGraphData() {
    if ("SCARED - Patient" in assessmentsData) {
      const labels = [];
      const values = [];

      assessmentsData["SCARED - Patient"].forEach((item) => {
        const formattedDate = moment(item?.created).format("MMM DD");
        labels.push(formattedDate);
        values.push(item["score"]);
      });
      const tempData = { labels, values };
      setScaredAssessmentData(tempData);
    }
    if ("Columbia - Patient" in assessmentsData) {
      const labels = [];
      const values = [];

      assessmentsData["Columbia - Patient"].forEach((item) => {
        const formattedDate = moment(item?.created).format("MMM DD");
        labels.push(formattedDate);
        values.push(item["score"]);
      });
      const tempData = { labels, values };

      setColumbiaAssessmentData(tempData);
    }
  }
  const [selectedAssessment, setSelectedAssessment] = useState([
    { label: "All Assessments", value: "All Assessments" },
  ]);
  const [selectedCareGiver, setSelectedCareGiver] = useState([
    {
      label: "All",
      value: "all",
    },
  ]);
  const [assessmentFilterValue, setAssessmentFilterValue] =
    useState(selectedAssessment);
  const [careGiverFilterValue, setCareGiverFilterValue] =
    useState(selectedCareGiver);

  useEffect(() => {
    setAssessmentFilterValue(selectedAssessment);
    setCareGiverFilterValue(selectedCareGiver);
  }, [selectedAssessment, selectedCareGiver]);
  function gatherDBTData(setter, type = "urges") {
    fetchDBTDetailsLogic({
      patient: patientID,
      start_date: dbtStartDate,
      end_date: dbtEndDate,
      type: type,
    })
      .then((res) => {
        if (res)
        setter(res.data);
      else  return [];
      })
      .catch((e) => {
        notify("Something went wrong", "error");
        console.log(e);
        return [];
      });
  }
  function gatherDBTChartData() {
    fetchDBTChartDataLogic({
      patient: patientID,
      start_date: dbtStartDate,
      end_date: dbtEndDate,
    })
      .then((res) => {
        setDbtChartData(res.data);
      })
      .catch((e) => {
        notify("Something went wrong", "error");
        console.log(e);
        return [];
      });
  }
  function bundleDBTAPIs() {
    if (process.env.REACT_APP_DASHBOARD_TYPE !== "youth") {
      return;
    }
    gatherDBTData(setDbtData);
    gatherDBTData(setCmData, "core_mindfulness");
    gatherDBTData(setIeData, "interpersonal_effectiveness");
    gatherDBTData(setDtData, "distress_tolerance");
    gatherDBTData(setErData, "emotion_regulation");
    gatherDBTData(setWtmpData, "wtmp");
    gatherDBTChartData();
  }
  function getPatientMessages() {
    getSinglePatientChat({
      to: patientID,
      sender:patientID,
      page: "1",
      page_size: "9999999", //Tune this lower once lazy loading is done
    })
      .then((res) => {
        if (res.status === 200) {
          let formattedData = {};
          //
          const messages = res.data?.results;
          messages.forEach((item) => {
            chatStructureHelper(
              item,
              formattedData,
              clinicianId,
              clinicianName
            );
          });
          setChatData(formattedData[patientID]);
        } else {
          notify(
            "Something went wrong while fetching messages, try again later!",
            "error"
          );
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  const bundlePatientAPIs = () => {
    setPatientID(parseInt(params?.patientid));
    checkPatientExists(patientID)
      .then()
      .catch((e) => {
        if (e.response.status === 400) {
          notify("This patient does not exist!", "error");
          navigate("/dashboard/home/");
        }
      });

    if (selectedProvider) {
      const id = patientID;
      const params = {
        clinic_id: selectedClinic?.clinic?.id,
        clinician_id: clinicianId,
      };
      dispatch(singlePatientLogic({ id, params }));
    } else {
      dispatch(singlePatientLogic({ id: patientID }));
    }
    dispatch(getPatientBHIDataLogic(patientID));
    dispatch(fetchRecentAssessmentsLogic(patientID));
    dispatch(fetchAssessmentTypesLogic());
    if(patientID) {
      dispatch(
        fetchAllAssessmentsLogic({
          patient_id: patientID.toString(),
          start_date: startDate,
          end_date: endDate,
        })
      );
    }
   
    dispatch(
      fetchPatientNotesLogic({
        patient: patientID,
        ordering: "-created",
      })
    );
    if (process.env.REACT_APP_DASHBOARD_TYPE !== "youth"){
      dispatch(fetchSDOHPatientResultsLogic(patientID));
    }
    
    setPatientAssessmentLoading(true);
    fetchPateintAssessmentsLogic(patientID)
      .then((result) => {
        setPatientAssessments(result.data);
      })
      .catch((error) => {
        notify("Something went wrong", "error");
        console.log(error);
      });
    setPatientAssessmentLoading(false);

    //*Getting all chats for this patient
    getPatientMessages();
  };

  function bundleYouthAPICalls() {
    //*Youth Only API Calls
    if (process.env.REACT_APP_DASHBOARD_TYPE === "youth") {
      // dispatch(fetchTWSCoordinatorLogic()); //TODO: Uncommenting this is causing data reloading glitch. Fix this
      dispatch(
        fetchDBTAssessmentsLogic({
          patient: patientID,
          start_date: dbtStartDate,
          end_date: dbtEndDate,
          date_range: true,
        })
      );
      // console.log("singlePatientData?.caregiver_id",singlePatientData?.caregiver_id)
      if (singlePatientData?.caregiver_id) {
        fetchCaregiverAssessments(singlePatientData?.caregiver_id);
        fetchCaregiverRecentAssessmentData(singlePatientData?.caregiver_id)
        fetchCaregiverAllAssessments({
          patient_id: singlePatientData?.caregiver_id,
          start_date: startDate,
          end_date: endDate,
        });

      }
      bundleDBTAPIs();
    }
  }
  useEffect(() => {
    bundlePatientAPIs();
    bundleYouthAPICalls();
    return () => {
      sessionStorage.removeItem("openChatIDMini");
    };
  }, [params]);

  useEffect(() => {
    if(patientID) {
      dispatch(
        fetchAllAssessmentsLogic({
          patient_id: patientID.toString(),
          start_date: startDate,
          end_date: endDate,
        })
      );
    }
    if( singlePatientData?.caregiver_id){
      fetchCaregiverAllAssessments({
        patient_id: singlePatientData?.caregiver_id,
        start_date: startDate,
        end_date: endDate,
      });
    }
   
  }, [startDate, endDate]);
  useEffect(() => {
    if (singlePatientData?.caregiver_id) {
      fetchCaregiverAssessments(singlePatientData?.caregiver_id);
      fetchCaregiverRecentAssessmentData(singlePatientData?.caregiver_id)
      fetchCaregiverAllAssessments({
        patient_id: singlePatientData?.caregiver_id,
        start_date: startDate,
        end_date: endDate,
      });
    }
  },[singlePatientData]);

  const [isModalOpen, setModalOpen] = useState(false);
  const [modalName, setModalName] = useState("Schedule Assessment");
  function handleAssessmentAction() {
    setModalName("Schedule Assessment");
    setModalOpen(true);
  }

  const handleDateRangeSelect = (range) => {
    setDateRange(range);
  };
  useEffect(() => {
    setdbtStartDate(moment(dateRange[0]).format("YYYY-MM-DD"));
    setdbtEndDate(moment(dateRange[1]).format("YYYY-MM-DD"));
  }, [dateRange]);

  useEffect(() => {
    bundleDBTAPIs();
  }, [dbtStartDate]);
  var Difference_In_Time =
    new Date(endDate).getTime() - new Date(startDate).getTime();

  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  return (
    <section
      className="container-fluid"
      style={{ margin: "0px", padding: "0px" }}
    >
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {capitalize(singlePatientData?.first_name || "Patient")}'s profile
        </title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <SearchPatientComponent />
      {/* {remoteShow && (
        <DualLoginModal modalIsOpen={remoteShow} setIsOpen={setRemoteShow} />
      )} */}

      {loading ? (
        <PatientLoader />
      ) : (
        <>
          <div className="container-fluid my-4">
            <PatientIntroLayer
              first_name={singlePatientData?.first_name}
              last_name={singlePatientData?.last_name}
              rose_chat={singlePatientData?.rose_chat}
              profile_picture={singlePatientData?.profile_picture}
              flag={singlePatientData?.flag}
              setPatientNotesTab={setPatientNotesTab}
              patientLoading={patientNotesLoading}
              patientNotes={patientNotes}
              setPinnedContentTab={setPinnedContentTab}
              setDBTContentTab={setDBTContentTab}
              bhiLoading={bhiLoading}
              patientData={singlePatientData}
              setIsChatExanpded={setIsChatExanpded}
              setDownloadMode={setDownloadMode}
            />
            <HorizontalSwitcherComponent
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
            />
            <div className="row mt-2 px-4">
              {currentTab === 1 && (
                <div className="row" style={{ margin: "0px", padding: "0px" }}>
                  <BasicInformation patientId={patientID} />
                  <FlaggedAssessments
                    assessmentData={recentAssessments}
                    patientId={patientID}
                    setAssessmentsTab={setAssessmentsTab}
                    loading={assessmentsLoading}
                    caregiverRecentAssessmentData={caregiverRecentAssessment}
                  />
                  {process.env.REACT_APP_DASHBOARD_TYPE === "youth" ? (
                    
                    <>
                    {/* <div
                          className="col-sm-12 col-md-5 col-lg-5"
                          style={{ margin: "0px", padding: "0px", }}
                        > */}
                            <FlaggedJournals  style={{ height: '500px' }}
                            setJournalsTab={setJournalsTab}
                            size={"5"}/> <GADAssessment setCheckinTab={setAssessmentsTab} />
                           
                     {/* </div> */}
                     
                        <div
                          className="col-sm-12 col-md-5 col-lg-5"
                          style={{ margin: "0px", padding: "0px",}}
                        >   <DBTStreak setDBTContentTab={setDBTContentTab}  />
                        </div>
                         </>
                  ) : (
                    <><GADAssessment setCheckinTab={setAssessmentsTab} />
                    <FlaggedJournals
                          setJournalsTab={setJournalsTab}
                          size={"5"} /></>
                  )}

                  {/* <CheckInOverviewTable setCheckinTab={setAssessmentsTab} /> */}
                  <PHQAssessment setCheckinTab={setAssessmentsTab} />
                  
                 
                 
                </div>
              )}
              {currentTab === 2 && (
                <div className="row" style={{ margin: "0px", padding: "0px" }}>
                  <div className="container-fluid">
                    <div className="d-flex my-2 justify-content-start">
                      <DateRangeComponent
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        showAssessmentFilter={true}
                        selectedAssessment={selectedAssessment}
                        setSelectedAssessment={setSelectedAssessment}
                        showCareGiverFilter={true}
                        selectedCareGiver={selectedCareGiver}
                        setSelectedCareGiver={setSelectedCareGiver}
                      />
                    </div>
                  </div>
                  <div
                    className="d-flex justify-content-end"
                    style={{ gap: "10px" }}
                  >
                    <PatientAssessmentModal
                      modalIsOpen={isModalOpen}
                      setModalOpen={setModalOpen}
                      patientId={patientID}
                      modalName={modalName}
                      data={patientAssessments}
                      setPatientAssessments={setPatientAssessments}
                      caregiverAssesments={caregiverAssesments}
                      setCaregiverAssessments={setCaregiverAssessments}
                    />
                    <PatientActionButton
                      icon={<CalendarIcon fill="#2D6A2B" />}
                      text={"Schedule Assessment"}
                      callBack={() => {
                        handleAssessmentAction();
                      }}
                      styles={{
                        color: "#2D6A2B",
                        backgroundColor: "#eafff5",
                      }}
                    />
                  </div>
                  {/* <CheckInOverviewTable
                    setCheckinTab={null}
                    size={
                      process.env.REACT_APP_DASHBOARD_TYPE === "youth"
                        ? "12"
                        : "7"
                    }
                  /> */}
                  <PHQAssessment setCheckinTab={null}
                    size={
                      process.env.REACT_APP_DASHBOARD_TYPE === "youth"
                        ? "12"
                        : "12"
                    } />
                     <GADAssessment setCheckinTab={null}
                    size={
                      process.env.REACT_APP_DASHBOARD_TYPE === "youth"
                        ? "12"
                        : "7"
                    } />
                  {process.env.REACT_APP_DASHBOARD_TYPE === "adult" && (
                    <SDOHResults
                      id={patientID}
                      first_name={singlePatientData?.first_name}
                    />
                  )}

                  {/* Scheduled Assessments */}
                  <PatientAssessment
                    setAssessmentsTab={setAssessmentsTab}
                    id={patientID}
                    assessmentLoading={assessmentLoading}
                    patientAssessments={patientAssessments}
                    setPatientAssessments={setPatientAssessments}
                    patientAssessmentLoading={patientAssessmentLoading}
                    caregiverAssesments={caregiverAssesments}
                    assessmentData={[
                      ...patientAssessments,
                      ...caregiverAssesments,
                    ]}
                    setCaregiverAssessments={setCaregiverAssessments}
                  />
                  <AllAssessments
                    setAssessmentsTab={setAssessmentsTab}
                    assessmentFilterValue={assessmentFilterValue}
                    careGiverFilterValue={careGiverFilterValue} 
                    caregiverAllAssesments={caregiverAllAssesments}
                  />
                  {/* journal analysis */}
                  <JournalAnalysis
                    patientId={patientID}
                    startDate={startDate}
                    endDate={endDate}
                  />
                  {process.env.REACT_APP_DASHBOARD_TYPE === "youth" && (
                    <>
                      <div
                        className="row"
                        style={{ margin: "0px", padding: "0px" }}
                      >
                        <ScaredAssessmentGraph
                          loading={assessmentLoading}
                          labels={scaredAssessmentData["labels"]}
                          data={scaredAssessmentData["values"]}
                          color={"#395E9D"}
                          title={"Youth SCARED Assessments"}
                        />
                        <ScaredAssessmentGraph
                          loading={assessmentLoading}
                          labels={columbiaAssessmentData["labels"]}
                          data={columbiaAssessmentData["values"]}
                          title={"Columbia Depression Scale"}
                        />
                      </div>
                      <div
                        className="row"
                        style={{ margin: "0px", padding: "0px" }}
                      >
                        <DailyPieChart
                          loading={assessmentLoading}
                          days={Difference_In_Days}
                          data={assessmentsData["Daily-DBT"]}
                          title={"Daily-DBT"}
                        />
                        <DailyPieChart
                          loading={assessmentLoading}
                          days={Difference_In_Days}
                          data={assessmentsData["Daily-Med"]}
                          title={"Daily-Med"}
                        />
                      </div>
                    </>
                  )}
                </div>
              )}
              {currentTab === 3 && (
                <div className="row" style={{ margin: "0px", padding: "0px" }}>
                  <CheckInOverview
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                  />
                </div>
              )}
              {currentTab === 4 && (
                <div className="row" style={{ margin: "0px", padding: "0px" }}>
                  <DateRangeComponent
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    journalFilterValue={journalFilterValue}
                    setJournalFilterValue={setJournalFilterValue}
                    journalDateFilter={true}
                  />
                  <Journals
                    journalFilterValue={journalFilterValue}
                    {...props}
                  />
                </div>
              )}
              {currentTab === 5 && (
                <div className="row" style={{ margin: "0px", padding: "0px" }}>
                  <DateRangeComponent
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    showNotesDD={true}
                    notesFilterValue={notesFilterValue}
                    setNotesFilterValue={setNotesFilterValue}
                    notesDownloadMode={notesDownloadMode}
                    setNotesDownloadMode={setNotesDownloadMode}
                  />
                  <PatientNotes
                    startDate={startDate}
                    endDate={endDate}
                    showTitle={true}
                    notesDownloadMode={notesDownloadMode}
                    setNotesDownloadMode={setNotesDownloadMode}
                    notesFilterValue={notesFilterValue}
                  />
                </div>
              )}
              {currentTab === 6 && <PinnedContent id={patientID} />}

              {currentTab === 7 && (
                <div className="row" style={{ margin: "0px", padding: "0px" }}>
                  <div className="row">
                    <div
                      className="col-sm-5 col-sm-offset-2 col-md-6 col-md-offset-0"
                      style={{
                        margin: "0px",
                        padding: "0px",
                      }}
                    >
                      <DateRangePicker
                        hoverRange="week"
                        ranges={[]}
                        oneTap
                        onChange={handleDateRangeSelect}
                        shouldDisableDate={combine(
                          allowedMaxDays(7),
                          afterToday()
                        )}
                        value={dateRange}
                      />
                    </div>
                  </div>
                  <DBTContent
                    patientId={patientID}
                    dbtStartDate={dbtStartDate}
                    dbtEndDate={dbtEndDate}
                    dbtData={dbtChartData}
                    name={"DBT Card"}
                  />

                  <DBTTable
                    patientId={patientID}
                    dbtStartDate={dbtStartDate}
                    dbtEndDate={dbtEndDate}
                    dbtData={dbtData}
                    name={"Urges"}
                  />
                  <DBTTable
                    patientId={patientID}
                    dbtStartDate={dbtStartDate}
                    dbtEndDate={dbtEndDate}
                    dbtData={cmData}
                    name={"Core Mindfulness"}
                  />
                  <DBTTable
                    patientId={patientID}
                    dbtStartDate={dbtStartDate}
                    dbtEndDate={dbtEndDate}
                    dbtData={ieData}
                    name={"Interpersonal Effectiveness"}
                  />
                  <DBTTable
                    patientId={patientID}
                    dbtStartDate={dbtStartDate}
                    dbtEndDate={dbtEndDate}
                    dbtData={dtData}
                    name={"Distress Tolerance"}
                  />
                  <DBTTable
                    patientId={patientID}
                    dbtStartDate={dbtStartDate}
                    dbtEndDate={dbtEndDate}
                    dbtData={erData}
                    name={"Emotion Regulation"}
                  />
                  <DBTTable
                    patientId={patientID}
                    dbtStartDate={dbtStartDate}
                    dbtEndDate={dbtEndDate}
                    dbtData={wtmpData}
                    name={"Walking the Middle Path"}
                  />
                </div>
              )}
              {currentTab === 8 && (
                <div className="row" style={{ margin: "0px", padding: "0px" }}>
                  <DateRangeComponent
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    showBillingNotes={true}
                    billingNotesFilter={billingNotesFilter}
                    setBillingsFilter={setBillingsFilter}
                    notesDownloadMode={notesDownloadMode}
                    setNotesDownloadMode={setNotesDownloadMode}
                  />
                  <BillingNotes
                    startDate={startDate}
                    endDate={endDate}
                    showTitle={true}
                    notesDownloadMode={notesDownloadMode}
                    setNotesDownloadMode={setNotesDownloadMode}
                    billingNotesFilter={billingNotesFilter}
                  />
                </div>
              )}
            </div>
          </div>
          {
            //window.location.origin === "http://localhost:3000" &&
            downloadMode && (
              <ProfilePDF
                startDate={startDate}
                endDate={endDate}
                setDownloadMode={setDownloadMode}
              />
            )
          }
        </>
      )}

      {/* <DummyClient /> */}
      <AgoraClientComponent
        callback={handleIncomingMessage}
        setRemoteShow={setRemoteShow}
      />
      {singlePatientData?.rose_chat && (
        <>
          <audio
            src={IncomingMessage}
            id="incomingMessageSound"
            muted
            autoPlay
          />
          {isChatExanpded ? (
            <MiniChat
              chatHistory={
                chatData?.messages?.length > 0
                  ? chatData?.messages.reverse()
                  : chatData?.messages
              }
              inChatMessage={inChatMessage}
              setInChatMessage={setInChatMessage}
              setExpanded={setIsChatExanpded}
              setUnreadCount={setUnreadCount}
              chatData={chatData}
              getPatientMessages={getPatientMessages}
            />
          ) : (
            <StickyChat
              setExpanded={setIsChatExanpded}
              user={singlePatientData?.first_name || ""}
              callBack={() => {}}
              unreadCount={unreadCount}
              getPatientMessages={getPatientMessages}
            />
          )}
        </>
      )}
    </section>
  );
};

export default PatientDashboard;
